import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Colors } from '../../styles/vars';

const StyledQuote = styled.blockquote`
  position: relative;
  display: flex;
  align-items: stretch;

  isolation: isolate;

  &::before,
  &::after {
    content: '';
    display: block;
    top: 0;
    left: 0;
  }

  &::before {
    width: 3em;

    background: linear-gradient(to right, currentColor, transparent);
    border: 1px solid ${Colors.pureWhite};
    border-right: none;

    opacity: 0.15;
  }

  &::after {
    position: absolute;
    width: 100%;
    height: 100%;

    background: currentColor;
    border: 1px solid ${Colors.pureWhite};
    opacity: 0.075;

    z-index: -1;
  }

  .children {
    padding: 0.75em 1.25em;
    padding-left: 0;
    flex: 1;

    filter: brightness(50%);
  }
`;

const Blockquote = ({ style, children }) => {
  return (
    <StyledQuote style={style}>
      <div className="children">{children}</div>
    </StyledQuote>
  );
};

Blockquote.propTypes = {
  style: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.node.isRequired,
};

Blockquote.defaultProps = {
  style: {},
};

export default Blockquote;
